// StaticInfo.jsx

import { Box, Typography, Container, useTheme, useMediaQuery } from '@mui/material';

const StaticInfo = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Container
      maxWidth="md"
      style={{
        display: 'flex',
        flexDirection: 'column',
        paddingTop: '4vh',
        paddingBottom:'25vh',
        justifyContent: 'center',
      }}
    >
      <Box
        p={isSmallScreen ? 2 : 4}
        textAlign="left"
        borderRadius={2}
        bgcolor={theme.palette.background.paper}
        boxShadow={3}
      >
        <Typography variant="h4" gutterBottom>
          [274 | O mana de ajutor]
        </Typography>
        <Typography variant="h5" gutterBottom>
          Aplicația 274
        </Typography>
        <Typography variant="body1" gutterBottom>
          Interfața Principală: Cu un design minimalist și intuitiv, 274 pune la dispoziție trei funcții esențiale:
        </Typography>
        <Typography variant="h6">Harta:</Typography>
        <Typography variant="body1" gutterBottom>
          Permite vizualizarea geografică a tuturor misiunilor postate. Utilizatorii pot vedea unde sunt concentrate nevoile și pot accesa detaliile misiunii printr-un simplu clic pe pin-ul de pe hartă.
        </Typography>
        <Typography variant="h6">Misiuni:</Typography>
        <Typography variant="body1" gutterBottom>
          Aici, utilizatorii pot parcurge misiunile în format de listă. Fiecare intrare în listă va afișa titlul, recompensa și o scurtă descriere. Un clic pe o intrare va oferi detalii suplimentare.
        </Typography>
        <Typography variant="h6">Adaugă:</Typography>
        <Typography variant="body1" gutterBottom>
          Acest buton deschide un proces simplu, structurat pe trei pași:
          <ul>
            <li>a. Selectarea Locației: Utilizatorii își pot defini locația exactă a misiunii folosind harta interactivă.</li>
            <li>b. Detalii Misiune: Aici se adaugă titlul, descrierea și recompensa pentru serviciul necesar. Descrierea detaliată ajută potențialii prestatori să înțeleagă cerințele misiunii.</li>
            <li>c. Încărcare Poze: Utilizatorii pot adăuga fotografii care să ilustreze nevoia sau detaliile specifice misiunii.</li>
          </ul>
        </Typography>
        <Typography variant="h6">Comunicarea:</Typography>
        <Typography variant="body1" gutterBottom>
          Pentru a menține simplitatea și eficiența, 274 se bazează pe comunicare directă. Fiecare misiune va afișa numărul de telefon al postatorului, astfel încât cei interesați să presteze serviciul să poată lua legătura rapid și direct. Acest mod de operare asigură o conexiune personală și imediată între persoanele care au nevoie de ajutor și cei dispuși să ofere acest ajutor.
        </Typography>
      </Box>
    </Container>
  );
};

export default StaticInfo;
